import { computed } from 'vue';

export function makeBaseItems() {
  return computed(() => []);
}
